import React, { useMemo } from 'react';
import { useQuery } from 'react-query';

import Error from 'components/templates/Error';
import HelmetComponent from 'container/Mainlayout/helmet';
import { errorTemplateCode } from 'navigation';
import { getStaticErrorsService } from 'services/navigation';
import { baseString, getBlockData } from 'utils/functions';

export type ErrorContainerProps = {
  statusCode?: number;
}

const ErrorContainer: React.FC<ErrorContainerProps> = ({ statusCode }) => {
  const { data: errors } = useQuery('getStaticError', getStaticErrorsService);

  const dataError = useMemo(() => {
    const blocks = errors?.find((e) => e.templateCode === errorTemplateCode(statusCode))?.blocks;
    const dataBlocks = getBlockData<DataStaticErrorBlockTypes>('introduction', blocks);

    return ({
      type: statusCode || 404,
      title: baseString(dataBlocks?.title),
      description: baseString(dataBlocks?.description),
      btnPrimary: {
        text: baseString(dataBlocks?.link1?.text),
        url: baseString(dataBlocks?.link1?.url),
        target: baseString(dataBlocks?.link1?.target),
      },
      btnOutline: {
        text: baseString(dataBlocks?.link2?.text),
        url: baseString(dataBlocks?.link2?.url),
        target: baseString(dataBlocks?.link2?.target),
      },
    });
  }, [errors, statusCode]);

  return (
    <>
      <HelmetComponent />
      <Error {...dataError} />
    </>
  );
};

export default ErrorContainer;
